// 仓库(包含自提派送)
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("warehousePickUpAndDeliver") || ""
}

const getters = {
  getWarehousePickUpAndDeliver:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("warehousePickUpAndDeliver",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("warehousePickUpAndDeliver")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}